<nb-card>
    <nb-card-header>
        <span style="font-size : 20px; font-weight:bold; color:Blue">Select Register Type</span> 
    </nb-card-header>
    <nb-card-body>
        <nb-card>
            <nb-card-body>
                <button nbButton (click)="registerAs('student')">Register As Student</button>
            </nb-card-body>
        </nb-card>
        <!-- <nb-card>
            <nb-card-body>
                <button nbButton (click)="registerAs('agent')">Register As Agent</button>
            </nb-card-body>
        </nb-card> -->
    </nb-card-body>
    <nb-card-footer>

    </nb-card-footer>
</nb-card>
